import { motion } from "framer-motion";

const steps = [
  {
    step: "01",
    title: "Racconti la tua storia",
    description: "Conduciamo interviste, raccogliamo ricordi, voce, modo di fare, carattere.",
    side: "left",
  },
  {
    step: "02",
    title: "Tu approvi",
    description: "Guardi, modifichi, confermi — finché non ti riconosci.",
    side: "right",
  },
  {
    step: "03",
    title: "Assembliamo la tua presenza",
    description: "Creiamo una versione digitale e mostriamo come funziona: come risponde, come suona, come si percepisce.",
    side: "left",
  },
  {
    step: "04",
    title: "Affini il risultato",
    description: "Raggiungiamo lo stadio in cui il 95% delle risposte corrisponde alla tua immagine. O la supera.",
    side: "right",
  },
  {
    step: "05",
    title: "I tuoi cari restano connessi",
    description: "Ricevono un accesso personale — per parlarti quando vogliono. Senza fretta. Senza rumore.",
    side: "left",
  },
];

export const HowItWorks = () => {
  return (
    <section id="come-funziona" className="py-24 lg:py-32 bg-gradient-section-alt relative">
      <div className="max-w-5xl mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-100px" }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16 lg:mb-20"
        >
          <h2 className="font-serif text-3xl sm:text-4xl lg:text-5xl font-bold text-foreground leading-tight">
            Come funziona
          </h2>
        </motion.div>

        {/* Timeline */}
        <div className="relative">
          {/* Vertical line */}
          <div className="absolute left-1/2 top-0 bottom-0 w-px bg-border -translate-x-1/2 hidden md:block" />

          <div className="space-y-12 md:space-y-0">
            {steps.map((item, index) => (
              <motion.div
                key={item.step}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
                className={`relative md:flex items-center ${
                  index > 0 ? "md:mt-16" : ""
                } ${item.side === "left" ? "md:flex-row" : "md:flex-row-reverse"}`}
              >
                {/* Content card */}
                <div className={`md:w-[calc(50%-2rem)] ${item.side === "left" ? "md:text-right md:pr-0" : "md:text-left md:pl-0"}`}>
                  <div className="bg-card border border-border/40 rounded-xl p-6 lg:p-8 shadow-card hover:shadow-medium transition-shadow duration-500">
                    <h3 className="font-serif text-lg font-bold text-foreground mb-2">{item.title}</h3>
                    <p className="text-sm text-muted-foreground leading-relaxed">{item.description}</p>
                  </div>
                </div>

                {/* Step number circle */}
                <div className="hidden md:flex absolute left-1/2 -translate-x-1/2 w-11 h-11 rounded-xl bg-success text-success-foreground items-center justify-center text-sm font-bold shadow-medium z-10">
                  {item.step}
                </div>

                {/* Mobile step badge */}
                <div className="md:hidden flex items-center gap-3 mb-3">
                  <div className="w-9 h-9 rounded-lg bg-success text-success-foreground flex items-center justify-center text-xs font-bold">
                    {item.step}
                  </div>
                  <span className="text-sm font-medium text-muted-foreground">Passo {item.step}</span>
                </div>

                {/* Spacer for the other side */}
                <div className="hidden md:block md:w-[calc(50%-2rem)]" />
              </motion.div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};
